import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal, Button } from 'react-bootstrap';
import Feedbacks from '../common/Feedbacks';
import { putRequest, postRequest } from '../../requestUtils';
import checkmarkImg from '../../../assets/images/check-mark.svg';
import './ProposalFeedbacks.scss';
var renderCheckmark = function renderCheckmark(showImage) {
  return showImage ? /*#__PURE__*/React.createElement("img", {
    src: checkmarkImg,
    className: "checkmark-img",
    alt: "check mark"
  }) : null;
};
var ProposalFeedbacks = /*#__PURE__*/function (_Component) {
  function ProposalFeedbacks(props) {
    var _this;
    _classCallCheck(this, ProposalFeedbacks);
    _this = _callSuper(this, ProposalFeedbacks, [props]);
    _this.state = {
      edit: props.id === null,
      isUpdate: props.id !== null,
      note: props.note,
      showModal: props.showModal,
      feedbacks: props.feedbacks,
      isProcessing: false,
      consultantFit: props.consultantFit,
      id: props.id
    };
    _this.handleShowModal = _this.handleShowModal.bind(_this);
    _this.handleCloseModal = _this.handleCloseModal.bind(_this);
    _this.handleInputChange = _this.handleInputChange.bind(_this);
    _this.handleOptionClick = _this.handleOptionClick.bind(_this);
    _this.updateFeedbackState = _this.updateFeedbackState.bind(_this);
    return _this;
  }
  _inherits(ProposalFeedbacks, _Component);
  return _createClass(ProposalFeedbacks, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props = this.props,
        feedbacks = _this$props.feedbacks,
        modalIsOpen = _this$props.modalIsOpen;

      // Compare the previous feedbacks with the current feedbacks to check for changes
      var feedbacksChanged = feedbacks.some(function (feedback) {
        var prevFeedback = prevProps.feedbacks.find(function (f) {
          return f.id === feedback.id;
        });
        return !prevFeedback || prevFeedback.note !== feedback.note || prevFeedback.consultant_fit !== feedback.consultant_fit;
      });
      if (!prevProps.modalIsOpen && modalIsOpen) {
        this.handleShowModal();
      } else if (prevProps.feedbacks !== feedbacks || feedbacksChanged) {
        this.updateFeedbackState();
      }
    }
  }, {
    key: "handleShowModal",
    value: function handleShowModal() {
      this.props.showModalCallback();
      this.setState({
        showModal: true
      });
    }
  }, {
    key: "handleCloseModal",
    value: function handleCloseModal() {
      this.setState({
        showModal: false
      });
    }
  }, {
    key: "handleInputChange",
    value: function handleInputChange(input, value) {
      this.setState(_defineProperty({}, input, value));
    }
  }, {
    key: "handleOptionClick",
    value: function handleOptionClick(event, value) {
      event.preventDefault();
      this.setState({
        consultantFit: value
      });
    }
  }, {
    key: "handleSubmit",
    value: function handleSubmit(isUpdate) {
      var _this2 = this;
      var _this$state = this.state,
        note = _this$state.note,
        feedbacks = _this$state.feedbacks,
        consultantFit = _this$state.consultantFit,
        id = _this$state.id;
      var oldFeedbacks = feedbacks;
      var _this$props2 = this.props,
        proposalResourceId = _this$props2.proposalResourceId,
        csrfToken = _this$props2.csrfToken,
        email = _this$props2.email,
        handleProposalAfterSubmit = _this$props2.handleProposalAfterSubmit,
        showNewProposalUX = _this$props2.showNewProposalUX;
      this.setState({
        isProcessing: true
      });
      if (isUpdate) {
        putRequest("/proposals/".concat(proposalResourceId, "/proposal_feedbacks/").concat(id), {
          proposal_feedback: {
            consultant_fit: consultantFit,
            note: note,
            email: email
          }
        }, csrfToken).then(function (_ref) {
          var data = _ref.data;
          var updatedFeedbacks = feedbacks.map(function (item) {
            return item.id === data.feedback.id ? _objectSpread(_objectSpread({}, item), data.feedback) : item;
          });
          _this2.setState({
            feedbacks: updatedFeedbacks,
            isProcessing: false,
            showModal: false,
            isUpdate: true,
            edit: false,
            id: data.id
          });
          if (showNewProposalUX) {
            handleProposalAfterSubmit(data.proposalDetails);
          }
        })["catch"](function () {
          _this2.setState({
            isProcessing: false
          });
        });
      } else {
        postRequest("/proposals/".concat(proposalResourceId, "/proposal_feedbacks/"), {
          proposal_feedback: {
            consultant_fit: consultantFit,
            note: note,
            email: email
          }
        }, csrfToken).then(function (_ref2) {
          var data = _ref2.data;
          _this2.setState({
            feedbacks: oldFeedbacks.concat(data.feedback),
            isProcessing: false,
            showModal: false,
            isUpdate: true,
            edit: false,
            id: data.id
          });
        })["catch"](function () {
          _this2.setState({
            isProcessing: false
          });
        });
      }
    }
  }, {
    key: "updateFeedbackState",
    value: function updateFeedbackState() {
      var _this$props3 = this.props,
        feedbacks = _this$props3.feedbacks,
        id = _this$props3.id,
        note = _this$props3.note,
        consultantFit = _this$props3.consultantFit;
      this.setState({
        edit: id === null,
        isUpdate: id !== null,
        note: note,
        feedbacks: feedbacks,
        consultantFit: consultantFit,
        id: id
      });
    }
  }, {
    key: "renderForm",
    value: function renderForm() {
      var _this3 = this;
      var candidateName = this.props.candidateName;
      var _this$state2 = this.state,
        note = _this$state2.note,
        isUpdate = _this$state2.isUpdate,
        isProcessing = _this$state2.isProcessing,
        consultantFit = _this$state2.consultantFit;
      return /*#__PURE__*/React.createElement("form", {
        className: "feedback-form"
      }, /*#__PURE__*/React.createElement("h2", {
        className: "header"
      }, "Is ".concat(candidateName, " a good fit for this project?")), /*#__PURE__*/React.createElement("div", {
        className: "sub-header"
      }, /*#__PURE__*/React.createElement("strong", null, "Only team members"), ' ', "will see your feedback."), /*#__PURE__*/React.createElement("div", {
        className: "button-group"
      }, /*#__PURE__*/React.createElement("button", {
        className: "option-button ".concat(consultantFit === 'yes' ? 'selected' : ''),
        onClick: function onClick(event) {
          return _this3.handleOptionClick(event, 'yes');
        }
      }, renderCheckmark(consultantFit === 'yes'), "Yes"), /*#__PURE__*/React.createElement("button", {
        className: "option-button ".concat(consultantFit === 'maybe' ? 'selected' : ''),
        onClick: function onClick(event) {
          return _this3.handleOptionClick(event, 'maybe');
        }
      }, renderCheckmark(consultantFit === 'maybe'), "Maybe"), /*#__PURE__*/React.createElement("button", {
        className: "option-button ".concat(consultantFit === 'no' ? 'selected' : ''),
        onClick: function onClick(event) {
          return _this3.handleOptionClick(event, 'no');
        }
      }, renderCheckmark(consultantFit === 'no'), "No")), /*#__PURE__*/React.createElement("div", {
        className: "fs-hide mb-2"
      }, /*#__PURE__*/React.createElement("textarea", {
        value: note !== null ? note : '',
        className: "form-control",
        placeholder: "Type your comments here...",
        name: "note",
        id: "note",
        rows: "4",
        onChange: function onChange(event) {
          return _this3.handleInputChange('note', event.target.value);
        }
      })), /*#__PURE__*/React.createElement("div", {
        className: "form-actions"
      }, isUpdate && /*#__PURE__*/React.createElement("button", {
        className: "btn btn-secondary-no-border me-2 cancel-edit-feedback",
        type: "button",
        onClick: function onClick() {
          return _this3.handleCloseModal();
        }
      }, "Cancel"), /*#__PURE__*/React.createElement("button", {
        className: "btn ".concat(consultantFit === null ? 'btn-disabled' : 'btn-primary'),
        type: "button",
        onClick: function onClick() {
          _this3.handleSubmit(isUpdate);
        },
        disabled: consultantFit === '' && isUpdate === false
      }, isUpdate ? 'Update Feedback' : 'Submit Feedback', isProcessing ? '...' : '')));
    }
  }, {
    key: "renderFeedbacks",
    value: function renderFeedbacks() {
      var _this$props4 = this.props,
        csrfToken = _this$props4.csrfToken,
        proposalResourceId = _this$props4.proposalResourceId,
        emailShareUrl = _this$props4.emailShareUrl,
        candidateName = _this$props4.candidateName,
        location = _this$props4.location,
        canEditFeedback = _this$props4.canEditFeedback,
        admin = _this$props4.admin,
        buttonStyles = _this$props4.buttonStyles,
        handleShowCoworkerModal = _this$props4.handleShowCoworkerModal,
        showNewProposalUX = _this$props4.showNewProposalUX;
      var _this$state3 = this.state,
        feedbacks = _this$state3.feedbacks,
        edit = _this$state3.edit;
      return /*#__PURE__*/React.createElement("div", {
        className: "proposal-feedbacks-container"
      }, /*#__PURE__*/React.createElement("div", {
        className: "proposal-feedbacks"
      }, /*#__PURE__*/React.createElement("div", {
        className: "comments-and-colleagues-collapsible show"
      }, /*#__PURE__*/React.createElement("h2", {
        className: "demibold mb-4 ".concat(buttonStyles, " ")
      }, "Team feedback on", ' ', candidateName), feedbacks.length === 0 ? /*#__PURE__*/React.createElement("div", {
        className: "empty-feedback"
      }, "No feedback yet. Tell your colleagues what you think to get the ball rolling, or invite them to leave their own feedback.") : /*#__PURE__*/React.createElement(Feedbacks, {
        canCreateFeedback: false,
        feedbacks: feedbacks,
        csrfToken: csrfToken,
        resource: "proposal",
        resourceId: proposalResourceId,
        emailShareUrl: emailShareUrl
      }), /*#__PURE__*/React.createElement("br", null), location === 'proposal' && /*#__PURE__*/React.createElement("div", {
        className: "btn-actions"
      }, !admin && canEditFeedback && edit && /*#__PURE__*/React.createElement(Button, {
        className: "btn-add-feedback",
        onClick: this.handleShowModal
      }, "Leave feedback"), showNewProposalUX ? /*#__PURE__*/React.createElement(Button, {
        onClick: function onClick() {
          return handleShowCoworkerModal();
        },
        tabIndex: 0,
        className: "btn-add-coworkers-feedback"
      }, "Share with a Colleague") : /*#__PURE__*/React.createElement(Button, {
        onClick: function onClick() {
          return $('.add-coworkers-button').click();
        },
        tabIndex: 0,
        className: "btn-add-coworkers-feedback"
      }, "Share with a Colleague")))));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props5 = this.props,
        canEditFeedback = _this$props5.canEditFeedback,
        admin = _this$props5.admin,
        location = _this$props5.location;
      var _this$state4 = this.state,
        edit = _this$state4.edit,
        showModal = _this$state4.showModal;
      return /*#__PURE__*/React.createElement("div", {
        className: "add-proposal-feedback-container style-guide box-shadow-1"
      }, !admin && canEditFeedback && edit && location === 'resume' && this.renderForm(), location === 'proposal' && this.renderFeedbacks(), /*#__PURE__*/React.createElement(Modal, {
        show: showModal,
        onHide: this.handleCloseModal,
        backdrop: "static",
        className: "edit-feedback-modal",
        size: "lg"
      }, /*#__PURE__*/React.createElement(Modal.Header, {
        closeButton: true,
        className: "no-border-bottom edit-feedback-modal-close"
      }), /*#__PURE__*/React.createElement(Modal.Body, null, this.renderForm())));
    }
  }]);
}(Component);
ProposalFeedbacks.propTypes = {
  canEditFeedback: PropTypes.bool.isRequired,
  candidateName: PropTypes.string.isRequired,
  proposalResourceId: PropTypes.string.isRequired,
  id: PropTypes.number.isRequired,
  feedbacks: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  email: PropTypes.string.isRequired,
  csrfToken: PropTypes.string.isRequired,
  admin: PropTypes.bool,
  emailShareUrl: PropTypes.string,
  consultantFit: PropTypes.string,
  note: PropTypes.string,
  location: PropTypes.string,
  buttonStyles: PropTypes.string,
  handleShowCoworkerModal: PropTypes.func,
  showModal: PropTypes.bool,
  showModalCallback: PropTypes.func,
  modalIsOpen: PropTypes.bool,
  handleProposalAfterSubmit: PropTypes.func,
  showNewProposalUX: PropTypes.bool
};
ProposalFeedbacks.defaultProps = {
  consultantFit: '',
  note: null,
  location: 'proposal',
  admin: false,
  emailShareUrl: '',
  buttonStyles: '',
  showModal: false,
  handleShowCoworkerModal: function handleShowCoworkerModal() {},
  showModalCallback: function showModalCallback() {},
  handleProposalAfterSubmit: function handleProposalAfterSubmit() {},
  modalIsOpen: false,
  showNewProposalUX: false
};
export default ProposalFeedbacks;